module.exports = __webpack_public_path__ + "img/l2.733cead9.png";